import pluralize from "pluralize";
import { formatNumberWithCommas } from "helpers/utility/formatters";
import styles from "./style.module.scss";

interface FinalReviewApplyContentProps {
  labeled: number;
  /** seed images: they keep their label, and count as labeled */
  seed: number;
  changed: number;
  unlabeled: number;
}

/** Body of the confirm modal shown before applying the final review labels */
export default function FinalReviewApplyContent({
  labeled,
  seed,
  changed,
  unlabeled,
}: FinalReviewApplyContentProps) {
  const total = labeled + seed;
  return (
    <div data-testid="final-review-apply-content">
      <p>
        {formatNumberWithCommas(total)} {pluralize("image", total)} will be
        labeled ({formatNumberWithCommas(changed)} changed by you,{" "}
        {formatNumberWithCommas(unlabeled)} left unlabeled).
        <br />
        This replaces any previous Label Propagation labels.
      </p>
      <p className={styles.warning}>
        Once applied, these labels cannot be edited.
        <br />
        Make sure you finished your review.
      </p>
    </div>
  );
}
